import { useMediaLibDialogStoreShallow } from "@editor/modules/media-lib";
import {
  type MediaLibPresetEnum,
  MediaPanelTabEnum,
} from "@editor/modules/media-lib/types";
import { MediaDialogAi } from "./media-dialog-ai";
import { MediaDialogGifs } from "./media-dialog-gifs";
import { MediaDialogHeader } from "./media-dialog-header";
import { MediaDialogLogoFinder } from "./media-dialog-logo-filder";
import { MediaDialogMyFiles } from "./media-dialog-my-files";
import { MediaDialogStockImages } from "./media-dialog-stock-images";
import { MediaDialogStockVideos } from "./media-dialog-stock-videos";
import { MediaDialogTabs } from "./media-dialog-tabs";

const MediaDialogComponents = {
  [MediaPanelTabEnum.StockImages]: MediaDialogStockImages,
  [MediaPanelTabEnum.StockVideos]: MediaDialogStockVideos,
  [MediaPanelTabEnum.MediaLib]: MediaDialogMyFiles,
  [MediaPanelTabEnum.LogoFinder]: MediaDialogLogoFinder,
  [MediaPanelTabEnum.Gifs]: MediaDialogGifs,
  [MediaPanelTabEnum.AiGenerate]: MediaDialogAi,
};

export const MediaDialog = ({ preset }: { preset: MediaLibPresetEnum }) => {
  const { selectedTab, setSelectedTab } = useMediaLibDialogStoreShallow(
    (s) => ({
      selectedTab: s.selectedTab,
      setSelectedTab: s.setSelectedTab,
    }),
  );
  const PanelComponent = MediaDialogComponents[selectedTab];

  return (
    <div className="tw-grid tw-size-full tw-grid-rows-[auto_auto_1fr] tw-content-start tw-overflow-auto tw-overscroll-contain tw-rounded-2xl -sm:tw-overflow-x-hidden -sm:tw-rounded-none">
      <MediaDialogHeader preset={preset} setSelectedTab={setSelectedTab} />

      <MediaDialogTabs
        selectedTab={selectedTab}
        setSelectedTab={setSelectedTab}
        preset={preset}
      />

      <PanelComponent />
    </div>
  );
};
